import { FC, PropsWithChildren } from 'react';
import { MenuItemsProvider } from '@shared/contexts/MenuItemsContext.tsx';
import menuItems from '@utils/menu-items';
import { DashboardProvider } from '@shared/contexts/DashboardContext.tsx';
import PageMetaProvider from '@providers/PageMetaProvider/ui/PageMetaProvider.tsx';
import { NotificationProvider } from '@shared/contexts/NotificationContext.tsx';
import HelpCenterProvider from '@providers/HelpCenterProvider/ui/HelpCenterProvider.tsx';
import DemandDocumentParserProvider from '@providers/DocumentParserProvider/ui/DemandDocumentParserProvider.tsx';
import { DocumentInstanceVersionChatProvider } from '@shared/contexts/DocumentInstanceVersionChatContext.tsx';
import { ChatSourceViewerProvider } from '@shared/contexts/ChatSourceViewerContext.tsx';
import WebsocketProvider from '@providers/WebsocketProvider/ui/WebsocketProvider.tsx';
import { ConfirmationModalProvider } from '@shared/contexts/ConfirmationModalContext.tsx';

/**
 * @description HOC component to have all the needed providers in one place.
 * Not all of them should be required at the dashboard level and could
 * be refactored by moving them to the appropriate level.
 */
const AppProvidersWrapper: FC<PropsWithChildren> = ({ children }) => {
  return (
    <DashboardProvider>
      <MenuItemsProvider initialItems={menuItems.items}>
        <NotificationProvider>
          <HelpCenterProvider>
            <DemandDocumentParserProvider>
              <DocumentInstanceVersionChatProvider>
                <ChatSourceViewerProvider>
                  <ConfirmationModalProvider>
                    <WebsocketProvider>
                      <PageMetaProvider>{children}</PageMetaProvider>
                    </WebsocketProvider>
                  </ConfirmationModalProvider>
                </ChatSourceViewerProvider>
              </DocumentInstanceVersionChatProvider>
            </DemandDocumentParserProvider>
          </HelpCenterProvider>
        </NotificationProvider>
      </MenuItemsProvider>
    </DashboardProvider>
  );
};

export default AppProvidersWrapper;
